import { gql } from '@apollo/client';

import { cartPartial, subscriptionPartial } from '../partials';

export const removeCoupon = gql`
mutation RemoveCouponMutation($code: [String!]) {
  removeCoupons(input: {codes: $code}) {
    ${cartPartial(subscriptionPartial)}
  }
}
`;
